/**
 * CompetitionPanel - Hızlı Eşleşme Modu Panel Bileşeni
 * Oyuncu sayısı seçimi ve matchmaking UI
 */

export const CompetitionPanel = () => `
    <div id="competition-panel" class="lobby-panel hidden">
        <div class="panel-header">
            <h3>⚔️ HIZLI EŞLEŞME MODU</h3>
            <button id="close-competition-panel" class="panel-close-btn">✕</button>
        </div>
        
        <div class="panel-content">
            <p class="panel-desc">
                Hızlı eşleşme ile rastgele rakipler bul ve 10 soruluk yarışmada yarış!
            </p>
            
            <div class="competition-settings">
                <label class="setting-label">Oyuncu Sayısı</label>
                <div class="player-count-selector">
                    <button class="player-count-btn active" data-count="2">
                        <span class="count">2</span>
                        <span class="label">Kişi</span>
                    </button>
                    <button class="player-count-btn" data-count="3">
                        <span class="count">3</span>
                        <span class="label">Kişi</span>
                    </button>
                    <button class="player-count-btn" data-count="4">
                        <span class="count">4</span>
                        <span class="label">Kişi</span>
                    </button>
                </div>
                
                <div class="competition-info">
                    <div class="info-item">
                        <span class="info-icon">📂</span>
                        <span class="info-text">Kategori: Karışık</span>
                    </div>
                    <div class="info-item">
                        <span class="info-icon">⏱️</span>
                        <span class="info-text">Süre: 15 saniye</span>
                    </div>
                    <div class="info-item">
                        <span class="info-icon">❓</span>
                        <span class="info-text">Soru: 10 adet</span>
                    </div>
                </div>
            </div>
            
            <div id="matchmaking-status" class="matchmaking-status hidden">
                <div class="searching-animation">
                    <div class="pulse-ring"></div>
                    <span class="search-icon">🔍</span>
                </div>
                <p class="status-text">Rakip aranıyor...</p>
                <button id="cancel-matchmaking-btn" class="gaddar-btn secondary">İptal</button>
                <button id="start-game-competition-btn" class="gaddar-btn primary pulse-btn hidden" style="margin-top: 15px; width: 100%;">
                    🚀 HAZIRIM
                </button>
            </div>
            
            <button id="start-matchmaking-btn" class="gaddar-btn primary large">
                <span class="btn-icon">🎮</span>
                <span class="btn-text">OYUN ARA</span>
            </button>
        </div>
    </div>
`;
